var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#slack_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E01E5A",
  d: "M13.504 40.448a6.72 6.72 0 0 1-6.72 6.72 6.72 6.72 0 0 1-6.72-6.72 6.72 6.72 0 0 1 6.72-6.72h6.72zm3.36 0a6.72 6.72 0 0 1 6.72-6.72 6.72 6.72 0 0 1 6.72 6.72v16.8a6.72 6.72 0 0 1-6.72 6.72 6.72 6.72 0 0 1-6.72-6.72z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#36C5F0",
  d: "M23.584 13.472a6.72 6.72 0 0 1-6.72-6.72 6.72 6.72 0 0 1 6.72-6.72 6.72 6.72 0 0 1 6.72 6.72v6.72zm0 3.392a6.72 6.72 0 0 1 6.72 6.72 6.72 6.72 0 0 1-6.72 6.72H6.72A6.72 6.72 0 0 1 0 23.584a6.72 6.72 0 0 1 6.72-6.72z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2EB67D",
  d: "M50.496 23.584a6.72 6.72 0 0 1 6.72-6.72 6.72 6.72 0 0 1 6.72 6.72 6.72 6.72 0 0 1-6.72 6.72h-6.72zm-3.36 0a6.72 6.72 0 0 1-6.72 6.72 6.72 6.72 0 0 1-6.72-6.72V6.72A6.72 6.72 0 0 1 40.416 0a6.72 6.72 0 0 1 6.72 6.72z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ECB22E",
  d: "M40.416 50.528a6.72 6.72 0 0 1 6.72 6.72 6.72 6.72 0 0 1-6.72 6.72 6.72 6.72 0 0 1-6.72-6.72v-6.72zm0-3.36a6.72 6.72 0 0 1-6.72-6.72 6.72 6.72 0 0 1 6.72-6.72H57.28a6.72 6.72 0 0 1 6.72 6.72 6.72 6.72 0 0 1-6.72 6.72z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "slack_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h64v64H0z"
})))));
export default SvgSlack;